<template>
  <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.63112 3.99993L0.564453 0.933263L1.267 0.230713L5.03622 3.99993L1.267 7.76915L0.564453 7.0666L3.63112 3.99993Z" fill="currentColor"/>
  </svg>
</template>